exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".xue-icon {\n  display: inline-flex;\n  fill: currentColor;\n  vertical-align: top;\n  overflow: hidden; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/packages/icon/style/index.scss
// module id = 83
// module chunks = 0